import { toast } from "react-toastify";
import { useAdminOrganizationContextControllerUpdateCurrent } from "service";
import { queryKeyFn } from "service/api/estabrookContext";
import { queryClient } from "@/query-client";

// Shared self-service mutation for the org's "customer reply email" -
// used both by the post-signup setup step (ESR-1614) and the Settings
// screen's Reply Email tab (ESR-1616). Unlike the super-admin-only
// organization update (`useAdminOrganizationControllerUpdate`), this hits
// the "current org" endpoint, so it works for any authenticated org admin.
const useUpdateReplyEmail = (onSuccess: () => void) => {
  const { mutate, isLoading } =
    useAdminOrganizationContextControllerUpdateCurrent({
      onSuccess: () => {
        queryClient.invalidateQueries(
          queryKeyFn({
            path: "/api/v1/admin/organizations/current",
            operationId: "adminOrganizationContextControllerGetCurrent",
            variables: {},
          }),
        );
        onSuccess();
      },
      onError: () => {
        toast.error("Couldn't update the reply email. Please try again.");
      },
    });

  const updateReplyEmail = (replyToEmail: string) => {
    mutate({ body: { replyToEmail: replyToEmail || null } });
  };

  return { updateReplyEmail, isLoading };
};

export default useUpdateReplyEmail;
